import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
// import { useFormik, useFormikContext } from "formik";
import { find } from "lodash";

import { Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  addNewMaintenance,
  MaintainaceTypeList,
  getMaintenanceList,
} from "../../../redux/actions/maintenanceAction";

import Cancel from "../../../assets/icons/x-circle.svg";
import Calendar from "../../../assets/icons/calendar.svg";
import AppDatePicker from "../../../components/Common/AppDatePicker";
import { MaintenanceType } from "./MaintenanceType";
import "../../../assets/styles/local/Maintenance.css";

export const RecurrenceModal = ({
  setMenuActive,
  record,
  showModal,
  setShowModal,
}) => {
  const dispatch = useDispatch();

  const maintenanceTypeList = useSelector(
    (state) => state.maintenance.maintenanceType
  );

  const assetId = window.localStorage.getItem("assetId");
  const clientId = window.localStorage.getItem("clientid");
  const [typeOfMaintainance, setTypeOfMaintenance] = useState("");
  const [maintenanceName, setMaintenanceName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  useEffect(() => {
    dispatch(MaintainaceTypeList());
  }, []);

  // const formik = useFormik({
  //   initialValues: {
  //     typeOfMaintainance: typeOfMaintainance,
  //     maintenanceName: "",
  //     startDate: "",
  //     endDate: "",
  //   },
  //   onSubmit: (values) => {
  //     alert(JSON.stringify(values, null, 2));
  //   },
  // });
  const handleSubmit = () => {
    dispatch(
      addNewMaintenance({
        associatedAssetId: assetId,
        maintainaceName: maintenanceName,
        workId: record.workId,
        typeOfMaintainance: typeOfMaintainance?.typeId,
        startDate: startDate,
        // endDate: endDate,
        statusId: record.status ? record.status.statusId : "",
        assignedTo: null,
        general: {
          assetId: assetId,
          client: clientId || record.general?.clientId,
          workDescription: "string",
        },
      })
    );
    if (assetId) {
      dispatch(getMaintenanceList(assetId));
    }
  };
  return (
    <section
      className="quote-menu quote-menu-2 recurrence-modal"
      style={{
        top: "0",
      }}
    >
      {true ? (
        <Recurrence
          maintenanceTypeList={maintenanceTypeList}
          setShowModal={setShowModal}
          setTypeOfMaintenance={setTypeOfMaintenance}
          typeOfMaintainance={typeOfMaintainance}
          showModal={showModal}
          setMaintenanceName={setMaintenanceName}
          maintenanceName={maintenanceName}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          endDate={endDate}
          startDate={startDate}
          dispatch={dispatch}
          handleSubmit={handleSubmit}
          setMenuActive={setMenuActive}
        />
      ) : (
        <TurnUnvailable setShowModal={setShowModal} showModal={showModal} />
      )}
    </section>
  );
};

const Recurrence = ({
  setShowModal,
  showModal,
  formik,
  typeOfMaintainance,
  setTypeOfMaintenance,
  maintenanceTypeList,
  setMaintenanceName,
  maintenanceName,
  setStartDate,
  setEndDate,
  endDate,
  startDate,
  handleSubmit,
  setMenuActive,
}) => {
  const Period = [
    { Key: 1, label: "Week", value: "week" },
    { Key: 2, label: "2 Weeks", value: "2weeks" },
    { Key: 3, label: "3 Weeks", value: "3weeks" },
    { Key: 4, label: "Month", value: "month" },
    { Key: 5, label: "2 Months", value: "2months" },
    { Key: 6, label: "Quarter", value: "quarter" },
    { Key: 7, label: "Semester", value: "semester" },
    { Key: 8, label: "Year", value: "year" },
  ];

  const [calendarStartDateIsOpen, setCalendarStartDateIsOpen] = useState(false);
  const [calendarEndtDateIsOpen, setCalendarEndtDateIsOpen] = useState(false);
  const [showMaintenanceTypeModal, setShowMaintenanceTypeModal] =
    useState(false);
  const [dateError, setDateError] = useState(false);
  const [] = useState();
  return (
    <Container className="p-4">
      <Row>
        <Col>
          <h4 className="bolder-text">
            Work Maintenance
            <br />
            Recurrence
          </h4>
        </Col>
      </Row>
      <Row className="mt-3 p-1">
        <Col>
          <h6 className="pb-2 bolder-text">Type of Maintenance</h6>
          <Input
            className="select-box"
            name="typeOfMaintainance"
            value={typeOfMaintainance.name}
            onClick={() => setShowMaintenanceTypeModal(true)}
          />
          {showMaintenanceTypeModal ? (
            <MaintenanceType
              typeOfMaintainance={typeOfMaintainance}
              setTypeOfMaintenance={setTypeOfMaintenance}
              maintenanceTypeList={maintenanceTypeList}
              setShowModal={setShowMaintenanceTypeModal}
              showModal={showMaintenanceTypeModal}
              formik={formik}
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row className="mt-2 px-3">
        <h6>Period</h6>
        <Col className="m-0 p-0">
          <div className="input-container" id="ascInput">
            <label className="asc-label-top projectNameText">
              {/* Period */}
              Every
            </label>

            <div className="recurrence-input ps-3">
              <select
                className="selection-box"
                value={maintenanceName}
                onChange={(e) => {
                  setMaintenanceName(e.target.value);
                }}
              >
                {Period.map((items) => (
                  <option key={items.id} value={items.value}>
                    {items.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Col>
        <Col className="px-3">
          <div className="input-container" id="ascInput">
            <label className="asc-label-top projectNameText">
              {/* Starting Date */}
              Starting Date
            </label>
            <div className="recurrence-input ps-2 flexContainer">
              <img
                className=" pointer"
                onClick={() => setCalendarStartDateIsOpen((p) => !p)}
                src={Calendar}
                alt=""
              />
              <AppDatePicker
                open={calendarStartDateIsOpen}
                selected={startDate}
                onChange={(val) => {
                  setStartDate(val);
                  setCalendarStartDateIsOpen(false);
                }}
                onSelect={(d, event) => {
                  setDateError(false);
                  event.preventDefault();
                }}
                isError={dateError}
                error={setDateError}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            {dateError && (
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <div class="warning-icon">!</div>
                <div class="warning-message">Please select a valid date.</div>
              </div>
            )}
          </div>
        </Col>
        <Col className="p-0">
          <div className="input-container" id="ascInput">
            <label className="asc-label-top projectNameText">
              {/* Ending Date */}
              Ending Date
            </label>
            <div className="recurrence-input ps-2 flexContainer">
              <img
                className="pointer"
                onClick={() => setCalendarEndtDateIsOpen((p) => !p)}
                src={Calendar}
                alt=""
              />
              <AppDatePicker
                open={calendarEndtDateIsOpen}
                selected={endDate}
                onChange={(val) => {
                  setEndDate(val);
                  setCalendarEndtDateIsOpen(false);
                }}
                onSelect={(d, event) => {
                  setDateError(false);
                  event.preventDefault();
                }}
                isError={dateError}
                error={setDateError}
                dateFormat="dd/MM/yyyy"
              />
            </div>
            {dateError && (
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <div class="warning-icon">!</div>
                <div class="warning-message">Please select a valid date.</div>
              </div>
            )}
          </div>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <div className="d-flex justify-content-center d-flex">
            <button
              type="button"
              className="addProCancel me-4"
              onClick={() => {
                setShowModal(!showModal);
              }}
            >
              Cancel
            </button>

            <button
              type="button"
              className="addProAdd"
              onClick={() => {
                handleSubmit();
                setShowModal(!showModal);
                setMenuActive(false);
              }}
            >
              Create
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const TurnUnvailable = ({ setShowModal, showModal }) => {
  return (
    <Container>
      <Row>
        <Col>
          <p>Turn Unavilable</p>
        </Col>
        <Col>
          <img
            src={Cancel}
            alt="close"
            onClick={() => setShowModal(!showModal)}
          />
        </Col>
        <Col sm={12}>
          <div className="d-flex">
            <span>
              <Form.Check // prettier-ignore
                type={"radio"}
                id={`default-radio`}
                label={""}
              />
            </span>
            <span>Definitive</span>
          </div>
          <Form.Control as="textarea" rows={3} />
        </Col>
        <Col sm={12}>
          <div className="d-flex">
            <span>
              <Form.Check // prettier-ignore
                type={"radio"}
                id={`default-radio`}
                label={""}
              />
            </span>
            <span>Temporary</span>
          </div>
          <p>
            From
            <span>
              <img src={Calendar} alt="close" />
            </span>
            <span>01.01.1999</span>
          </p>
          <p>
            To
            <span>
              <img src={Calendar} alt="calendar" />
            </span>
            <span>01.01.1999</span>
          </p>
        </Col>
      </Row>
    </Container>
  );
};
